import { render } from "./SocialMedia.html?vue&type=template&id=fd33fd30&scoped=true&ts=true"
import script from "./SocialMedia.ts?vue&type=script&lang=ts"
export * from "./SocialMedia.ts?vue&type=script&lang=ts"

import "./SocialMedia.scss?vue&type=style&index=0&id=fd33fd30&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd33fd30"]])

export default __exports__